export default __webpack_public_path__ + "static/media/JM.6b490554.svg";